module.exports=d=>new Promise(r=>setTimeout(r,d))